import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const UserProfile = () => {
  const { user, updateProfile, loading, error } = useAuth();
  const [formData, setFormData] = useState({
    full_name: '',
    organization: '',
  });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (user) {
      setFormData({
        full_name: user.full_name || '',
        organization: user.organization || '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');

    try {
      await updateProfile(formData);
      setMessage('Profile updated successfully!');
    } catch (err) {
      setMessage(`Error: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="user-profile">
        <div className="loading">Loading profile...</div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="user-profile">
        <div className="error-message">User not found</div>
      </div>
    );
  }

  return (
    <div className="user-profile">
      <h2>User Profile</h2>

      <div className="profile-info">
        <div className="profile-section">
          <h3>Account Information</h3>
          <div className="info-grid">
            <div className="info-item">
              <label>Email</label>
              <span>{user.email}</span>
            </div>
            <div className="info-item">
              <label>User ID</label>
              <span>{user.id}</span>
            </div>
            <div className="info-item">
              <label>Account Created</label>
              <span>{new Date(user.created_at).toLocaleDateString()}</span>
            </div>
            <div className="info-item">
              <label>Subscription Tier</label>
              <span className={`tier tier-${user.subscription_tier}`}>
                {user.subscription_tier}
              </span>
            </div>
          </div>
        </div>

        <div className="profile-section">
          <h3>Update Profile</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="full_name">Full Name</label>
              <input
                type="text"
                id="full_name"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                required
                disabled={saving}
              />
            </div>

            <div className="form-group">
              <label htmlFor="organization">Organization</label>
              <input
                type="text"
                id="organization"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                disabled={saving}
                placeholder="Optional"
              />
            </div>

            {message && (
              <div className={`message ${message.includes('Error') ? 'error' : 'success'}`}>
                {message}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary"
              disabled={saving}
            >
              {saving ? 'Saving...' : 'Update Profile'}
            </button>
          </form>
        </div>

        <div className="profile-section">
          <h3>Account Actions</h3>
          <div className="action-buttons">
            <button className="btn btn-outline">
              Change Password
            </button>
            <button className="btn btn-outline">
              Email Settings
            </button>
            <button className="btn btn-outline">
              Download Data
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
